import { Injectable } from '@angular/core';
import { downloadFile } from '@marmon/frontend/common';
import { createCsvBlob, fileName } from '@marmon/shared/types/common';
import {
	ExportName,
	ExportPayload,
	GeneratingExport,
} from '@marmon/shared/types/export';
import { BehaviorSubject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class ExportStateService {
	readonly generating$ = new BehaviorSubject<GeneratingExport | null>(null);

	readonly startGeneratingData = (payload: ExportPayload<any>) => {
		this.generating$.next({ startedAt: new Date(), payload });
	};

	updateGeneratingData(data: Partial<GeneratingExport>) {
		const value = this.generating$.value;
		if (!value) this.generating$.next(data as GeneratingExport);
		else this.generating$.next({ ...value, ...data });
	}

	endGeneratingData(csv?: string) {
		const value = this.generating$.value;
		if (!value) throw Error('No data is being generated');
		this.generating$.next({ ...value, csv, endedAt: new Date() });
	}

	readonly clearExport = () => this.generating$.next(null);

	downloadExport() {
		const value = this.generating$.value;
		if (!value || !value.csv) throw Error('No csv is available');

		downloadFile(
			createCsvBlob(value.csv),
			fileName(ExportName('invoices'), 'csv'),
		);
	}
}
